import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import type { GetDriverVehicleSivDataResponse } from "@qivia/schemas-office";
import { RootState } from "../../../redux/store";
import { QueryStatus, axiosInstanceWithPhoneToken } from "../../../utils";

export interface VehicleState {
  sivDataStatus: QueryStatus;
  sivData: GetDriverVehicleSivDataResponse | null;
}

const initialState: VehicleState = {
  sivDataStatus: "idle",
  sivData: null,
};

export const getVehicleSivDataAsync = createAsyncThunk(
  "getVehicleSivData/call/",
  async (payload: { vehicleUuid: string }) => {
    const phoneToken = localStorage.getItem("phoneToken");
    if (!phoneToken) {
      throw Error();
    }
    const axios = axiosInstanceWithPhoneToken(phoneToken);
    const response = await axios.get<GetDriverVehicleSivDataResponse>(
      `/driver_access/vehicle/${payload.vehicleUuid}/siv_data`,
    );
    return response.data;
  },
);

export const vehicleSlice = createSlice({
  name: "vehicle",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getVehicleSivDataAsync.pending, (state) => {
        state.sivDataStatus = "processing";
      })
      .addCase(getVehicleSivDataAsync.fulfilled, (state, action) => {
        state.sivData = action.payload;
        state.sivDataStatus = "success";
      })
      .addCase(getVehicleSivDataAsync.rejected, (state) => {
        state.sivDataStatus = "failed";
      });
  },
});

export const selectVehicleSivData = (state: RootState) => state.vehicle.sivData;
export const selectVehicleSivDataStatus = (state: RootState) =>
  state.vehicle.sivDataStatus;

export default vehicleSlice.reducer;
